import { isProduction } from "common/utils/env";
import { EventBus, Events } from "jiffy-store";
import "./product-mosaic.scss";

const ROOT_SELECTOR = ".js-product-mosaic";
const MOSAIC_IMAGE_SELECTOR = ".mosaic-image";

const $getMosaics = () => document.querySelectorAll(ROOT_SELECTOR);
const $getMosaicImage = $mosaic => $mosaic.querySelector(MOSAIC_IMAGE_SELECTOR);
const $getMosaicFromElement = $element => $element?.closest?.(ROOT_SELECTOR);

function handleMosaicClick(e) {
  e.stopPropagation();
  e.preventDefault();

  EventBus.publish(Events.TOGGLE_PRODUCT_COLOR_PICKER, e.currentTarget);
}

const keydownCallback = e => {
  if (e.keyCode === 13 || e.keyCode === 32) {
    handleMosaicClick(e);
  }
};

const handleMosaicImageError = e => {
  const imageSrc = e.target?.src || "unknown";
  const $mosaic = $getMosaicFromElement(e.target);
  const productId = $mosaic?.dataset?.productId || null;

  if (isProduction()) {
    window.Honeybadger?.notify?.("Product mosaic image failed to load", {
      name: "ProductMosaicImageError",
      context: {
        productId,
        imageSrc
      },
      fingerprint: "ProductMosaicImageError"
    });
  }
};

export default () => {
  const $elMosaics = $getMosaics();

  $elMosaics.forEach($mosaic => {
    const $mosaicImage = $getMosaicImage($mosaic);

    $mosaic.addEventListener("click", handleMosaicClick);
    $mosaic.addEventListener("keydown", keydownCallback);
    if ($mosaicImage) {
      $mosaicImage.onerror = handleMosaicImageError;
    }
  });

  return () => {
    $elMosaics.forEach($mosaic => {
      const $mosaicImage = $getMosaicImage($mosaic);
      $mosaic.removeEventListener("click", handleMosaicClick);
      $mosaic.removeEventListener("keydown", keydownCallback);
      if ($mosaicImage) {
        $mosaicImage.onerror = null;
      }
    });
  };
};
